import React from 'react';

interface PicnicTableIconProps {
  className?: string;
}

const PicnicTableIcon: React.FC<PicnicTableIconProps> = ({ className = "w-6 h-6" }) => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      className={className}
    >
      {/* Table top */}
      <path d="M2 10 L22 10" />
      {/* Bench left */}
      <path d="M4 14 L8 14" />
      {/* Bench right */}
      <path d="M16 14 L20 14" />
      {/* Left leg */}
      <path d="M5 10 L3 20" />
      {/* Right leg */}
      <path d="M19 10 L21 20" />
      {/* Center support */}
      <path d="M12 10 L12 20" />
      {/* Bench supports */}
      <path d="M6 14 L5 18" />
      <path d="M18 14 L19 18" />
    </svg>
  );
};

export default PicnicTableIcon;
